import { render, staticRenderFns } from "./TripReportDialog.vue?vue&type=template&id=2b59720c"
import script from "./TripReportDialog.vue?vue&type=script&lang=js"
export * from "./TripReportDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports